/* 
 *  Copyright © Ludvik Michalek, Bigfoot Interactive
 *  http://www.bigfoot.cz/
 */

const MAP_INIT_TRY_COUNT_MAX = 5;

let page;
let mapInitTryCount = 0;


$(document).ready(function () {

	// global init
	page = new HomepageController();
	
	let cookieBar = new CookieBar('#cookie-bar', 'cookies-agree', 5);
	
	NavigationUtils.initScrollToElementLinks();
	
	// object-fit css polyfill
	objectFitImages();
	
});


/*
 * Google Maps API callback
 * Async, check for page controller ready before map initialization
 */
function mapInitCallback(){
	mapInitTryCount ++;
	if (page) {
		page.initMaps();
	} else {
		if (mapInitTryCount < MAP_INIT_TRY_COUNT_MAX) {
			setTimeout(mapInitCallback, 1000);
		}
	}
}
